import { Field } from '../PreviewFields';
import { PreviewHeader } from '../PreviewHeader';

export interface GstFormValues {
  gstNumber: string;
}

export interface GstVerificationScreenProps {
  /** Live form values — pass from the session runtime; omit in the builder mock. */
  values?: GstFormValues;
  onChange?: (patch: Partial<GstFormValues>) => void;
  /** Validation message (session runtime) — shown under the field. */
  gstError?: string;
  /** Method display name ("GST Verification") — shown for consistency with the
   *  other preview screens (Bank, PAN) that display their active method. */
  method?: string;
}

// GST Verification — the applicant enters their GSTIN; the provider confirms the
// GSTIN is active and returns business details. Single method (Whitebooks basic
// GSTIN lookup). OWN interim design — swap for the designer's screen when it arrives.
export function GstVerificationScreen({ values, onChange, gstError }: GstVerificationScreenProps) {
  return (
    <>
      <PreviewHeader title="GST Verification" subtitle="Enter your GST identification number" />
      <Field
        label="GSTIN"
        placeholder="27AAAPL0000A1Z5"
        hint="15-character GST Identification Number"
        value={values?.gstNumber}
        onChange={onChange ? (v) => onChange({ gstNumber: v.toUpperCase() }) : undefined}
        error={gstError}
      />
      <p className="mt-2 text-[14px] leading-tight text-[#666666]">
        Your GSTIN is verified securely against the GST registry. We do not store your personal
        information beyond what is required by law.
      </p>
    </>
  );
}
